import React from 'react';

const SAPLogo = (props) => (
  <svg viewBox="0 0 92 45" width="70" height="35" {...props}>
    <path
      d="M0 45h46L91 0H0v45"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="#b2b2b2"
    />
    <path
      d="M54 9h-9v21.1L37.2 9h-7.8l-6.7 17.7c-.7-4.5-5.4-6-9-7.2-2.4-.8-5-1.9-4.9-3.2 0-1 1.4-2 4.1-1.9 1.8.1 3.4.2 6.6 1.8l3.1-5.4c-2.9-1.5-6.9-2.4-10.1-2.4-3.8 0-7 1.2-9 3.3-1.4 1.4-2.1 3.2-2.1 5.2 0 2.7 1 4.7 3.1 6.3 1.8 1.3 4.1 2.2 6.1 2.8 2.5.8 4.5 1.4 4.5 2.9 0 .5-.2 1-.6 1.4-.6.6-1.6.9-2.9.9C8.9 31.1 7 30.7 4 29l-2.8 5.5c3 1.7 6.2 2.6 9.8 2.6h.8c3.1-.1 5.7-.8 7.7-2.4l.3-.3-.2 1.6h7.6l1.4-3.5c1.4.5 3.1.8 4.8.8 1.7 0 3.3-.3 4.7-.7L39 36h13.6v-7.9h2.9c7 0 11.1-3.6 11.1-9.5C66.6 11.9 62.5 9 54 9zM33.3 27.1c-1 0-2-.2-2.9-.5l2.8-9h.1l2.8 9c-.8.3-1.8.5-2.8.5zm21.2-5.2h-2v-7.2h2c2.6 0 4.7.9 4.7 3.6s-2.1 3.6-4.7 3.6"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="#fff"
    />
    <path d="M0 0h92v45H0V0z" fill="none" />
  </svg>
);

export default SAPLogo;
